import { Component, Inject, Input } from '@angular/core';
import { CmsPartialComponentClass } from 'lib/components/cms/cms-partial-component.class';
import { CategoryService } from 'lib/services/category/category.service';
import { RouterService } from 'lib/services/router.service';
import { WebpService } from 'lib/services/webp.service';
import { CommonModule, Location } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SpecialModule } from 'lib/modules/special.module';

@Component({
    selector: 'cms-partial-category-top-internal-links',
    templateUrl: './internal-links.component.html',
    styleUrls: ['./internal-links.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule, SpecialModule],
})
export class InternalLinksComponent extends CmsPartialComponentClass {
    @Input() internalLinksRow: any;
    getWebpImg: (src: string) => string;

    constructor(
        @Inject('environment') environment: any,
        routerService: RouterService,
        webpService: WebpService,
        location: Location,
        categoryService: CategoryService
    ) {
        super({
            dependencies: {
                environment,
                routerService,
                location,
                categoryService,
                webpService,
            },
        });
        this.getWebpImg = (src: string) => webpService.getWebpImg(src);
    }

    getLinkUrl(url: string): string {
        return this.getCategoryPageLink(url);
    }
}
